import { DeviceBehfa_Interface } from "./DeviceBehfa_Interface";

export interface DeviceBehfa_Cabinet_Interface {
  id:number,
  title:String,
  dsc: String,
  active :Array<DeviceBehfa_Interface>,
  disactive :Array<DeviceBehfa_Interface>,
  repair :Array<DeviceBehfa_Interface>,
  calibration :Array<DeviceBehfa_Interface>,
  outDevice :Array<DeviceBehfa_Interface>,
  inDevice :Array<DeviceBehfa_Interface>,
}


export function Empty_DeviceBehfa_Cabinet_Interface():DeviceBehfa_Cabinet_Interface{
  return{
    id:0,
    title:'',
    dsc: '',
    active :[],
    disactive :[],
    repair :[],
    calibration :[],
    outDevice :[],
    inDevice :[],
  }
}
